/* OXXRING RFQ UI layer (WP1): one dropzone in front of attachment_1..3, request-type hint and "more" disclosure.
   Validation and submission stay in oxx-vnext-rfq.js: files are placed into the named slots in order and a change
   event is fired on each slot, so the existing type/size checks run unchanged. */
(function () {
  'use strict';
  var ICON_FILE = '<svg class="ic-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/></svg>';
  var ICON_X = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  function bytes(b) { return b >= 1048576 ? (b / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(b / 1024)) + ' KB'; }

  function initDrop(form) {
    var drop = form.querySelector('[data-rfq-drop]');
    if (!drop || drop.dataset.ready) return;
    drop.dataset.ready = '1';
    var pick = drop.querySelector('[data-rfq-pick]'), zone = drop.querySelector('[data-rfq-drop-zone]');
    var list = drop.querySelector('[data-rfq-files]'), text = drop.querySelector('[data-rfq-drop-text]');
    var slots = Array.prototype.slice.call(drop.querySelectorAll('[data-rfq-slot]'));
    var errorBox = form.querySelector('[data-rfq-error]'), dropError = drop.querySelector('[data-rfq-drop-error]');
    var canTransfer = true;
    try { new DataTransfer(); } catch (e) { canTransfer = false; }

    // File problems are shown at the dropzone; the form-level box below the fields is left for submit errors.
    function showError(message) {
      drop.classList.toggle('is-error', Boolean(message));
      if (dropError) { dropError.hidden = !message; dropError.textContent = message || ''; }
      if (errorBox && message) { errorBox.hidden = true; errorBox.textContent = ''; }
    }

    function free() { return slots.filter(function (s) { return !(s.files && s.files.length); }); }
    function render() {
      list.replaceChildren();
      slots.forEach(function (slot) {
        var file = slot.files && slot.files[0];
        if (!file) return;
        var li = document.createElement('li'); li.className = 'ic-rfq__file'; li.innerHTML = ICON_FILE;
        var name = document.createElement('span'); name.className = 'ic-rfq__file-name'; name.textContent = file.name;
        var size = document.createElement('span'); size.className = 'ic-rfq__file-size'; size.textContent = bytes(file.size);
        var remove = document.createElement('button'); remove.type = 'button'; remove.innerHTML = ICON_X; remove.setAttribute('aria-label', 'Remove ' + file.name);
        remove.addEventListener('click', function () {
          slot.value = '';
          slot.dispatchEvent(new Event('change', { bubbles: true }));
          showError('');
          render();
          pick.focus();
        });
        li.append(name, size, remove);
        list.appendChild(li);
      });
      var open = free().length, used = slots.length - open;
      list.hidden = !used;
      drop.classList.toggle('is-full', !open);
      text.innerHTML = !open ? '<strong>3 files added.</strong> Remove one to add another.'
        : used ? '<strong>Add another file</strong> or <u>browse</u>' : '<strong>Drag files here</strong> or <u>browse</u>';
      pick.disabled = !open;
      // Without DataTransfer the zone opens the next empty slot itself (one file per click).
      if (!canTransfer) zone.htmlFor = open ? free()[0].id : pick.id;
    }
    function add(files) {
      var message = '';
      Array.prototype.forEach.call(files || [], function (file) {
        var slot = free()[0];
        if (!slot) { message = 'You can attach up to 3 files. Remove one to add another.'; return; }
        var transfer = new DataTransfer();
        transfer.items.add(file);
        slot.files = transfer.files;
        slot.dispatchEvent(new Event('change', { bubbles: true }));
        // oxx-vnext-rfq.js empties the slot and writes the reason into the form error box when a file is rejected.
        if (!(slot.files && slot.files.length) && errorBox && errorBox.textContent) message = file.name + ': ' + errorBox.textContent;
      });
      render();
      showError(message);
    }

    pick.addEventListener('change', function () { if (canTransfer) add(pick.files); pick.value = ''; });
    slots.forEach(function (slot) {
      slot.addEventListener('change', function () {
        render();
        // Fallback path (no DataTransfer): the slot itself was picked, so surface its validation here too.
        if (!canTransfer && errorBox && errorBox.textContent) showError(errorBox.textContent);
      });
    });
    ['dragenter', 'dragover'].forEach(function (type) {
      zone.addEventListener(type, function (event) { event.preventDefault(); if (free().length) drop.classList.add('is-over'); });
    });
    ['dragleave', 'dragend'].forEach(function (type) {
      zone.addEventListener(type, function () { drop.classList.remove('is-over'); });
    });
    zone.addEventListener('drop', function (event) {
      event.preventDefault();
      drop.classList.remove('is-over');
      if (canTransfer && event.dataTransfer) add(event.dataTransfer.files);
    });
    render();
  }

  function initTypes(form) {
    var more = form.querySelector('[data-rfq-more]'), hint = form.querySelector('[data-rfq-hint]');
    function sync() {
      var radio = form.querySelector('input[name="inquiry"]:checked');
      if (more && radio && more.contains(radio)) more.open = true;
      if (hint) {
        var text = radio && radio.getAttribute('data-hint');
        hint.hidden = !text;
        hint.textContent = text || '';
      }
    }
    form.addEventListener('change', function (event) { if (event.target && event.target.name === 'inquiry') sync(); });
    sync();
    window.setTimeout(sync, 0);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-rfq-root] [data-oxx-rfq]'), function (form) {
      initDrop(form);
      initTypes(form);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
